import { Validator } from '@vista-digital/validator';
import { cssColorNames } from './css-colour-names';
const colorNameFormat = new RegExp(cssColorNames.join('|'));
const hexFormat = /^#([\da-fA-F]{3,4}){1,2}$/;
/**
 * Valid css colours:
 * Contain EITHER rgb values or percentages, but not both.
 * rgb can EITHER be space separated or comma separated, but not both.
 * rgba needs to be comma separated, unless the alpha value is omitted.
 * The alpha value can be provided regardless of whether rgb or rgba is used.
 * Values above 255 or 100% are allowed.
 * Decimal values are allowed for both rgb values and percentages.
 * Negative values or percentages are allowed, HOWEVER, the alpha value cannot be negative.
 */
const rgbFormat = /^rgba?\((?:\s*-?\d+(?:\.\d+)?(?<abs>%?)\s*(?<sep>[,\s])\s*)(?:\s*-?\d+(?:\.\d+)?(\k<abs>)\s*(\k<sep>)\s*)(?:\s*-?\d+(\.\d+)?(\k<abs>)\s*)\)$/;
const rgbaFormat = /^rgba?\((?:\s*-?\d+(?:\.\d+)?(?<absRGBA>%?)\s*,)(?:\s*-?\d+(?:\.\d+)?(\k<absRGBA>)\s*,){2}(?:\s*\d+(?:\.\d+)?%?\s*)\)$/;
const cssColorValidationFormat = new RegExp(colorNameFormat.source + '|' + hexFormat.source + '|' + rgbFormat.source + '|' + rgbaFormat.source, 'i');
export const cssColourValidator = Validator.string({ format: cssColorValidationFormat });
//# sourceMappingURL=css-colour.js.map